export default "__VITE_ASSET__0W93yT6G__"